import React, { useLayoutEffect } from 'react';
import EmptyComponent from 'design-system/EmptyComponent';
import { AppView, Button, ButtonGroup, rem, RequestActionView, } from 'design-system';
import { IconSquareCircle } from 'design-system/icons';
import IconInfoTriangle from 'design-system/icons/IconInfoTriangle';
import useColors from 'hooks/useColors';
const strings = {
    errResultTitle: 'Couldn’t connect to Google Sheets',
    errResultDescription: 'We weren’t able to get permission to update your spreadsheet. Please try again.',
    closeButtonLabel: 'Close',
    retryButtonLabel: 'Try again',
};
const ExportDataLiveRetryScreen = ({ navigation, }) => {
    const colors = useColors();
    useLayoutEffect(() => {
        navigation.setOptions({
            gestureEnabled: false,
            headerLeft: EmptyComponent,
        });
    }, []);
    return (<AppView withFrame={false}>
      <RequestActionView title={strings.errResultTitle} subTitle={strings.errResultDescription} renderIcon={() => (<IconSquareCircle width={rem(88)} height={rem(88)} color={colors.status.negativeLight}>
            <IconInfoTriangle width={54} height={54}/>
          </IconSquareCircle>)}>
        <ButtonGroup type="floating">
          <Button brandReversed title={strings.closeButtonLabel} onPress={() => navigation.goBack()}/>
          <Button brand title={strings.retryButtonLabel} onPress={() => navigation.replace('ExportDataLiveTransit', {
            manageIfEnabled: true,
        })}/>
        </ButtonGroup>
      </RequestActionView>
    </AppView>);
};
export default ExportDataLiveRetryScreen;
